var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148px",
    height: "70px",
    viewBox: "0 0 148 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-1.33096801e-15 0 147 0 147 70 -1.33096801e-15 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 147 0 147 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loading-",
    transform: "translate(-977.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds",
    transform: "translate(192.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-2",
    transform: "translate(785.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0201144693,51.198526 C-0.715748817,38.7594743 18.983416,42.0329089 18.983416,42.0329089 C18.983416,42.0329089 13.0982534,21.9558429 46.8834458,29.1573992 C46.8834458,29.1573992 48.4092287,13.8813707 63.4490885,22.3923009 C63.4490885,22.3923009 89.3185193,-10.7785038 118.159303,3.62460875 C147.000413,18.0277213 133.635101,44.6516567 133.635101,44.6516567 C133.635101,44.6516567 145.841364,43.1240538 146.931209,51.198526 C148.021054,59.2729982 136.250729,68.6568443 110.748358,60.3641431 C110.748358,60.3641431 107.057707,67.2016935 94.633475,66.9834645 C82.2092429,66.7652355 75.0014446,58.6183113 75.0014446,58.6183113 C75.0014446,58.6183113 70.206127,65.6016386 57.127988,61.237059 C57.127988,61.237059 49.3682922,80.6594381 21.1631058,61.673517 C21.1631058,61.673517 0.755977756,63.6375778 0.0201144693,51.198526",
    id: "Fill-1",
    fill: "#5082F2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,10.8552972 C144.451323,17.6930747 132.662595,23.2996979 111.117076,16.2227754 C111.117076,16.2227754 107.412297,23.1579823 94.9316611,22.9365517 C82.4510248,22.7151211 75.2078765,14.4513304 75.2078765,14.4513304 C75.2078765,14.4513304 70.3907888,21.5371102 57.2532769,17.1084979 C57.2532769,17.1084979 49.4583532,36.8158228 21.1251192,17.5513591 C21.1251192,17.5513591 1.74290991,19.4379479 0,7.93241308 C0.253991897,8.36641709 6.63882269,17.2750137 22.5176954,12.0155937 C30.514061,18.2156509 47.6655207,23.3475269 64.4526335,1.90330023 C64.4526335,1.90330023 63.7300703,9.8136876 68.9903301,10.6763813 C74.2505898,11.5381892 79.6334664,8.73310619 84.3778599,0.909519622 C84.2114514,1.37009531 84.6695126,4.37800881 81.4587047,11.0209273 C81.4587047,11.0209273 94.1819471,17.9384198 103.402729,8.89696485 C112.62351,-0.145375838 116.564764,-2.48634032 116.273111,2.75447952 C115.980583,7.99529937 117.21726,13.2334621 128.716963,9.46914156 C131.344465,15.4477682 141.29832,15.3370529 147,10.8552972",
    id: "Fill-4",
    fill: "#426BC8",
    mask: "url(#mask-4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud-2.d9e443662de857a92f66811962b1dce9.svg";
export { ForwardRef as ReactComponent };